import { Box, Stack } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Pages } from '../assets/icons';
import moment from 'moment/moment';
import React from 'react';
import { getConfig } from '../../../util/configUtil';

const useStyles = makeStyles((theme) => {
    return {
        root: {},
        annotation: {
            display: 'flex',
            padding: '10px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '10px',
            borderRadius: '5px',
            alignSelf: 'stretch',
            backgroundColor: theme.palette.documentViewer.tabBackgroundColor,
            marginBottom: '16px',
            '--pages-icon-color': theme.palette.documentViewer.buttonsBackgroundColor,
        },
        annotationPage: {
            display: 'flex',
            alignItems: 'center',
            fontSize: '12px',
            position: 'relative',
            '& .icon': {
                width: '26px',
                height: '26px',
            },
            '& .icon-page': {
                width: '18px',
                position: 'absolute',
                color: theme.palette.documentViewer.contrastTextColor,
                fontWeight: '600',
                fontSize: '11px',
                textAlign: 'center',
            },
        },
        annotationUser: {
            fontWeight: '700',
            fontSize: '12px',
        },
        annotationDate: {
            fontStyle: 'italic',
            fontWeight: '300',
            fontSize: '12px',
        },
    };
});

export function AnnotationReactItem(props) {
    const defaultDateTimeFormat = getConfig('defaultDateTimeFormat');
    const { text, page, user_id, lastModifiedDate } = props;
    const classes = useStyles();
    const [annotateDate, setAnnotateDate] = React.useState('');

    React.useEffect(() => {
        if (lastModifiedDate) {
            const date = moment(lastModifiedDate);
            setAnnotateDate(date.format(defaultDateTimeFormat));
        }
    }, [lastModifiedDate]);

    return (
        <Stack className={classes.annotation} direction={'column'}>
            <Box>{text}</Box>
            <Stack direction={'row'} gap={'10px'} alignItems={'center'} justifyContent={'flex-start'} width={'100%'}>
                <Box>
                    <Box className={classes.annotationPage}>
                        <Pages className={'icon'} color={'var(--pages-icon-color)'}></Pages>
                        <Box className={'icon-page'}>{page}</Box>
                    </Box>
                </Box>
                <Stack direction={'column'}>
                    <Box className={classes.annotationUser}>{user_id}</Box>
                    <Box className={classes.annotationDate}>{annotateDate}</Box>
                </Stack>
            </Stack>
        </Stack>
    );
}
